import * as React from 'react';
import { Header } from '../header';
import { renderMenuItem } from './menu';
import { IMenuNavItem } from './types';

export interface IAppHeaderProps {
  logoLabel: string;
  logoLink: string | undefined;
  logoSrc: string;
  showMenu?: boolean;
  menuItems: IMenuNavItem[];
  className?: string;
}

export const AppHeader: React.FC<IAppHeaderProps> = ({
  logoLabel,
  logoLink,
  logoSrc,
  showMenu = true,
  menuItems,
  className,
}) => {
  const navItems = showMenu ? menuItems.map((i, index) => renderMenuItem(i, index)) : null;
  return (
    <Header slim={true} logoLabel={logoLabel} logoLink={logoLink} logoSrc={logoSrc} className={className}>
      {navItems}
    </Header>
  );
};

export default AppHeader;
